'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Icon = function Icon(props) {
    return _react2.default.createElement(
        'div',
        { style: { display: 'flex' } },
        _react2.default.createElement(
            'svg',
            {
                height: props.height,
                width: props.width,
                version: '1.1',
                viewBox: '0 0 24 24',
                xmlns: 'http://www.w3.org/2000/svg'
            },
            _react2.default.createElement(
                'g',
                { fill: 'none', fillRule: 'evenodd', stroke: 'none', strokeWidth: '1' },
                _react2.default.createElement('path', { d: 'M1 5h22v14.667H1z' }),
                _react2.default.createElement('path', {
                    d: 'M8.508 8.283c2.37 0 4.29 1.813 4.29 4.05 0 2.236-1.92 4.05-4.29 4.05-2.368 0-4.29-1.814-4.29-4.05 0-2.237 1.922-4.05 4.29-4.05z',
                    fill: '#FFF'
                }),
                _react2.default.createElement('path', {
                    d: 'M15.307 8.283c2.37 0 4.292 1.813 4.292 4.05 0 2.236-1.922 4.05-4.292 4.05s-4.29-1.814-4.29-4.05c0-2.237 1.921-4.05 4.29-4.05z',
                    fill: '#FFAF38'
                }),
                _react2.default.createElement('path', {
                    d: 'M8.508 8.283c2.37 0 4.29 1.813 4.29 4.05 0 2.236-1.92 4.05-4.29 4.05-2.368 0-4.29-1.814-4.29-4.05 0-2.237 1.922-4.05 4.29-4.05z',
                    fill: '#EB3636'
                }),
                _react2.default.createElement('path', {
                    d: 'M11.045 12.319c0 .927.335 1.779.89 2.462.55-.68.88-1.528.88-2.448 0-.928-.334-1.78-.891-2.463a3.89 3.89 0 0 0-.879 2.449z',
                    fill: '#F57137'
                })
            )
        )
    );
};

Icon.propTypes = {
    fill: _propTypes2.default.string,
    width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
};

Icon.defaultProps = {
    fill: null,
    width: '24px',
    height: '24px'
};

Icon.displayName = 'Mastercard';

exports.default = Icon;